var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn",class:{ [`btn-${_vm.flavor}`]: true, [`btn-${_vm.color}`]: true, [`btn-${_vm.size}`]: true, 'btn-block': _vm.block, active: _vm.active },attrs:{"type":_vm.type,"role":"button","disabled":_vm.disabled,"aria-label":_vm.label||false,"title":_vm.label||false}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }